export default [
    {   //商品管理
        path: "setting/productmanage",
        name: "settingtProductmanage",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/productmanage/index"),
    },
    // listing
    {   //商品管理
        path: "setting/listing",
        name: "settingtListing",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/listing/index1"),
    },
    {
        path: "setting/listing/update/:type",
        name: "settingtListingUpdate",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/listing/update"),
    },
    // 项目维护
    {   //商品管理
        path: "setting/linemaintain",
        name: "settingtlinemaintain",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/linemaintain/index"),
    },
    {
        path: "setting/linemaintain/update/:type",
        name: "settingtlinemaintainUpdate",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/setting/linemaintain/update"),
    },
]


